import { render, staticRenderFns } from "./set-welcome.vue?vue&type=template&id=2d06fffc&scoped=true"
import script from "./set-welcome.vue?vue&type=script&lang=js"
export * from "./set-welcome.vue?vue&type=script&lang=js"
import style0 from "./set-welcome.vue?vue&type=style&index=0&id=2d06fffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06fffc",
  null
  
)

export default component.exports